import styled from 'styled-components';
import { DecorationImage, MEDIA_QUERY, Stack, StackItem, withBreakpointRange } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { LocalizedParagraph, WithBreakpointRange, isMobile, isMobileOrTablet, isTablet } from '@mews-commander/ui';
import { capitalExtraFundingImage as capitalExtraFundingImagePath } from '@mews-commander/assets';
import { LocalizedSectionTitleLarge } from '../../components/Typography';
import { ExtraFundingLayout } from '../../components/Layouts/ExtraFundingLayout';
import { BORDER_RADIUS_400 } from '../../capitalThemeConstants';
import { FundingInvestments } from './FundingInvestments';

const Image = styled(DecorationImage)`
    border-radius: ${BORDER_RADIUS_400};
    height: 480px;
    width: 520px;

    ${MEDIA_QUERY.tabletMax} {
        height: 420px;
        width: 360px;
    }

    ${MEDIA_QUERY.largePhoneMax} {
        height: 280px;
        width: 100%;
    }
`;

const ImageWrapper = styled(Stack)`
    position: relative;
    width: 100%;
`;

export const ExtraFundingSectionComponent: React.FC<WithBreakpointRange> = ({ breakpointRange }) => (
    <ExtraFundingLayout>
        <Stack alignment="center">
            <ImageWrapper alignment="center">
                <Image src={capitalExtraFundingImagePath} alt="ExtraFunding" />
                {!isMobileOrTablet(breakpointRange) && <FundingInvestments />}
            </ImageWrapper>
        </Stack>
        <Stack alignment="center" itemAlignment="center">
            <StackItem
                maxWidth={(isMobile(breakpointRange) && '100%') || (isTablet(breakpointRange) && '340px') || '430px'}
            >
                <Stack spacing="300" vertical>
                    <LocalizedSectionTitleLarge textKey={TextKey.FinancialServicesCapitalWhatCouldYouDoWithFunding} />
                    <LocalizedParagraph textKey={TextKey.FinancialServicesCapitalYouDecide} />
                </Stack>
            </StackItem>
        </Stack>
    </ExtraFundingLayout>
);

export const ExtraFundingSection = withBreakpointRange(ExtraFundingSectionComponent);
